import useSessionContext from '../data/queryHooks/useSessionContext';
import {
	ProviderUserType,
	ProviderUserTypeGroup,
} from '../scripts/providerUserType';

/**
 * Custom hook to determine the subaccount level page type based on current session context
 * @returns {string} The page type string for the subaccount level
 */
const useSubaccountLevelPageType = () => {
	const { providerUserType, providerUserTypeGroup } = useSessionContext();
	const getSubaccountLevelPageType = (
		providerUserType,
		providerUserTypeGroup
	) => {
		switch (providerUserTypeGroup) {
			case ProviderUserTypeGroup.Clinical:
				return 'ClinicalNonRehab';
			case ProviderUserTypeGroup.Rehab:
				return 'Rehab';
			case ProviderUserTypeGroup.HealthplanAdmin:
				return 'HPAdmins';
			case ProviderUserTypeGroup.HealthplanProvider:
				if (
					providerUserType ===
					ProviderUserType.HealthplanProviderAnthemSISC
				) {
					return 'HPProvidersSISC';
				}
				if (
					providerUserType ===
					ProviderUserType.HealthplanProviderOscar
				) {
					return 'HPProvidersOscar';
				}
				//TODO: Verify which page type CignaPhysicalMedicine should be
				return 'HPProvidersOscar';
			default:
				return null;
		}
	};

	return getSubaccountLevelPageType(providerUserType, providerUserTypeGroup);
};

export default useSubaccountLevelPageType;
